import React, { useEffect, useState } from 'react';
import api from '../api';
import { useSortedPaginated, SortableTh, Pagination } from '../components/TableControls';
import { formatDateTime } from '../utils/dateUtils';

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const { paginated, sortKey, sortDir, setSort, page, setPage, perPage, setPerPage, total } = useSortedPaginated(logs, 'timestamp', 'desc');

  useEffect(() => {
    api.get('/reports/audit-log').then(r => setLogs(r.data));
  }, []);

  return (
    <div>
      <div className="page-header"><h1>Registro de Auditoría</h1></div>

      <div className="card">
        <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <SortableTh colKey="timestamp" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Fecha y Hora</SortableTh>
                <SortableTh colKey="user_name" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Usuario</SortableTh>
                <SortableTh colKey="action" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Acción</SortableTh>
                <SortableTh colKey="entity_type" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Entidad</SortableTh>
                <th>Antes</th>
                <th>Después</th>
                <th>Motivo</th>
              </tr>
            </thead>
            <tbody>
              {paginated.map(l => (
                <tr key={l.id}>
                  <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>
                    {formatDateTime(l.timestamp)}
                  </td>
                  <td>{l.user_name}</td>
                  <td><span className="badge badge-info">{l.action}</span></td>
                  <td>{l.entity_type} {l.entity_id ? `#${l.entity_id}` : ''}</td>
                  <td style={{ fontSize: 12, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.before_value || '-'}</td>
                  <td style={{ fontSize: 12, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.after_value || '-'}</td>
                  <td>{l.reason || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
      </div>
    </div>
  );
}
